var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintingPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16667 5.16602C3.97005 5.16602 3 6.13607 3 7.33268V11.4993H4.78571V12.4993H2.9C2.40294 12.4993 2 12.0964 2 11.5993V7.33268C2 5.58378 3.41777 4.16602 5.16667 4.16602H11.8333C13.5822 4.16602 15 5.58378 15 7.33268V11.5993C15 12.0964 14.5971 12.4993 14.1 12.4993H12.2143V11.4993H14V7.33268C14 6.13607 13.03 5.16602 11.8333 5.16602H5.16667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33203 2.5V4.66667H5.33203V2.4C5.33203 1.90294 5.73497 1.5 6.23203 1.5H10.7654C11.2624 1.5 11.6654 1.90294 11.6654 2.4V4.66667H10.6654V2.5H6.33203Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60178 9.83398L5.07797 13.5007H11.925L11.4012 9.83398H5.60178ZM11.9413 13.6148C11.9413 13.6148 11.9413 13.6147 11.9413 13.6148ZM4.6241 9.60671C4.68744 9.16332 5.06716 8.83398 5.51505 8.83398H11.4879C11.9358 8.83398 12.3155 9.16332 12.3788 9.60671L12.9312 13.4734C13.0087 14.0156 12.588 14.5007 12.0403 14.5007H4.96267C4.41498 14.5007 3.99426 14.0156 4.07171 13.4734L4.6241 9.60671Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1732 6.29437C12.3784 6.4791 12.3951 6.79525 12.2103 7.0005L12.2037 7.00791C12.019 7.21316 11.7028 7.2298 11.4976 7.04507C11.2923 6.86034 11.2757 6.5442 11.4604 6.33894L11.4671 6.33154C11.6518 6.12628 11.9679 6.10964 12.1732 6.29437Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintingPage);
export default __webpack_public_path__ + "static/media/printing-page.2b9a77cb57dd0e46bf970a65796bc05b.svg";
export { ForwardRef as ReactComponent };